import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { OrderContainer } from '../../../models/order/order.model';
import { catchError, map } from 'rxjs/operators';
import { ProductContainer } from 'src/app/models/interface/product/product.model';
import { ChangeRequest } from 'src/app/layout/products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-cfs/product-depth-level-cfs-actions/change-service/change-service.component';

export interface CtoResponse {
  codigocto: string;
  codigosp1: string;
  codigosp2: string;
  estadopuerto: string;
  puertocto: string;
  puertosp2: string;
  ubicacioncto: string;
}

export interface QueryCtoResponse {
  codResultado: string;
  descResultado: string;
  listactos: {
    cto: CtoResponse[]
  };
}

export interface ChangeCtoResponse {
  codResultado: string;
  descResultado: string;
  idadministrativo: string;
  codigoctofinal: string;
  puertoctofinal: string;
  codigosp2FINAL: string;
  puertosp2FINAL: string;
  olt: string;
  tarjeta: string;
  puertoPON: string;
  gestorvertical: string;
  ontid: string;
}

export interface ChangeFsanResponse {

}

export interface IuaHistorical {
  historicoadministrativos: {
    idadmininstrativo: string[]
  };
}

export interface ActivationObject {
  operador: string;
  idadministrativo: string;
  onu: string;
  password: string;
}

export interface ActivationEnterpriseObject {
  operador: string;
  idadministrativo: string;
  onu: string;
  password: string;
  cvlan1: string;
  cvlan2: string;
  cvlan3: string;
  cvlan4: string;
  cvlan5: string;
  avlan1: string;
  avlan2: string;
  avlan3: string;
  avlan4: string;
  avlan5: string;
  svlan: string;
}

export interface ActivationEnterpriseVfObject {
  operador: string;
  idadministrativo: string;
  onu: string;
  password: string;
  cvlan1: string;
  cvlan2: string;
  cvlan3: string;
  cvlan4: string;
  cvlan5: string;
}

export interface CancellationObject {
  operador: string;
  idadministrativo: string;
}

export interface TerminationObject {
  operador: string;
  idadministrativo: string;
}

export interface InstallationObject {
  operador: string;
  idadministrativo: string;
  codigocto: string;
  posicionsplitter: number;
  reutilizaacometida: string;
  propietarioacometida: string;
}

export interface ChangeServiceObject {
  operador: string;
  idadministrativo: string;
  template: string;
  tvremoteid: string;
}

export interface ChangeCpeObject {
  idadministrativo: string;
  cpeModel: String;
  cpeMac: String;
}

@Injectable({
  providedIn: 'root'
})
export class FtthService {

  appData: any

  constructor(
    private httpClient: HttpClient,
    appService: AppService,
  ) {
    this.appData = appService.settings;
  }

  createOrder(order: OrderContainer): Observable<void> {
    return this.httpClient.post<void>(`${this.appData.webApi}/crm-integration/api/orders/create`, order);
  }

  reserve(product: ProductContainer): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/reserve`, product, {});
  }

  activation(object: ActivationObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/activation`, object, {});
  }

  activationEnterprise(object: ActivationEnterpriseObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/activationCorporate`, object, {});
  }

  activationEnterpriseVf(object: ActivationEnterpriseVfObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/activationCorporateVf`, object, {});
  }

  installation(object: InstallationObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/installation`, object, {});
  }

  changeService(object: ChangeServiceObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/changeService`, object, {});
  }

  changeCpe(object: ChangeCpeObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/changeCpe`, object, {});
  }

  changeCpeRetailIntegrated(object: ChangeCpeObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/changeCpeRetailIntegrated`, object, {});
  }

  cancellation(object: CancellationObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/cancellation`, object, {});
  }

  termination(object: TerminationObject): Observable<any> {
    return this.httpClient.post<any>(`${this.appData.webApi}/ftth/termination`, object, {});
  }

  change(changeRequest: ChangeRequest): Observable<void> {
    return this.httpClient.post<void>(`${this.appData.webApi}/crm-integration/api/orders/change`, changeRequest);
  }

  getIuaHistorical(operador: string, idadministrativo: string): Observable<IuaHistorical> {
    return this.httpClient.post<IuaHistorical>(`${this.appData.webApi}/ftth/iuaHistorical`, { operador, idadministrativo });
    /*
    return of({
      "historico": [
          "A5010AAA0019",
          "A5082AAA0020",
          "A5904AAA0021",
          "A5010AAA0001"
      ]
    });
    */
  }

  queryCto(territoryUser: string, serviceId: string, ino: string, ctoCode?: string): Observable<QueryCtoResponse> {
    const body = {
      operador: territoryUser,
      idadministrativo: serviceId
    };

    if (ctoCode) {
      body['codigocto'] = ctoCode;
    }

    if (ino) {
      body['ino'] = ino;
    } else {
      body['ino'] = this.appData.portalOwner;
    }

    return this.httpClient.post<QueryCtoResponse>(`${this.appData.webApi}/ftth/queryCTO`, body, {});
  }

  changeCto(
    territoryUser: string,
    serviceId: string,
    origin: { ctoCode: string; splitterCode: string; splitterPort: string; },
    destination: { ctoCode: string; ctoPort: string; splitterCode: string; splitterPort: string; },
    changeReason: string,
    ino: string
  ): Observable<ChangeCtoResponse> {

    const body = {
      operador: territoryUser,
      idadministrativo: serviceId,
      codigoctoorigen: origin.ctoCode,
      codigosp2ORIGEN: origin.splitterCode,
      puertosp2ORIGEN: origin.splitterPort,
      codigoctofinal: destination.ctoCode,
      puertoctofinal: destination.ctoPort,
      codigosp2FINAL: destination.splitterCode,
      puertosp2FINAL: destination.splitterPort,
      motivodecambio: changeReason
    };

    if (ino) {
      body['ino'] = ino;
    } else {
      body['ino'] = this.appData.portalOwner;
    }

    return this.httpClient.post<ChangeCtoResponse>(`${this.appData.webApi}/ftth/changeCTO`, body, {});
  }

  changeFSAN(newFsan: string, iua: string, operator: string): Observable<ChangeFsanResponse> {
    const body = {
      fsan: newFsan,
      operator: operator
    }
    const params = {
      iua: iua
    }
    return this.httpClient.patch<any>(`${this.appData.webApi}/ftth/fsan`, body, { params });
  }

  updateFSAN(newFsan: string, iua: string, operator: string): Observable<ChangeFsanResponse> {
    const body = {
      fsan: newFsan,
      operator: operator
    }
    const params = {
      iua: iua
    }
    return this.httpClient.patch<any>(`${this.appData.webApi}/ftth/update_fsan`, body, { params });
  }

  changeOntPassword(newPassword: string, iua: string, operator: string): Observable<any> {
    const body = {
      ontPassword: newPassword,
      operator: operator
    }
    const params = {
      iua: iua
    }
    return this.httpClient.patch<any>(`${this.appData.webApi}/ftth/ont_password`, body, { params });
  }

  test(serviceId: string, test: string, territoryUser: string, ino: string): Observable<any> {
    const headers = new HttpHeaders().append('isp', territoryUser);
    const params: any = {
      operador: territoryUser,
      iua: serviceId,
      test: test
    };
    if (ino) {
      params.ino = ino;
    } else {
      params.ino = this.appData.portalOwner;
    }

    return this.httpClient.get<any>(`${this.appData.webApi}/ftth/test`, { headers, params });
  }
}
